import { isContinuous, isDiscrete } from "@visactor/vscale";

import { continuousTicks } from "./continuous";

import { linearDiscreteTicks } from "./discrete/linear";

import { polarAngleAxisDiscreteTicks } from "./discrete/polar-angle";

import { convertDomainToTickData } from "./util";

export const ticks = (scale, op) => {
    if (isContinuous(scale.type)) return continuousTicks(scale, op);
    if (isDiscrete(scale.type)) {
        if ("cartesian" === op.coordinateType) return linearDiscreteTicks(scale, op);
        if ("polar" === op.coordinateType && "angle" === op.axisOrientType) return polarAngleAxisDiscreteTicks(scale, op);
    }
    return convertDomainToTickData(scale.domain());
};
//# sourceMappingURL=ticks.js.map
